import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ServerProvider } from './context/ServerContext';
import { CookiesProvider } from './context/CookiesContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<BrowserRouter basename={document.settings.baseName}>
			<CookiesProvider>
				<ServerProvider>
					<App />
				</ServerProvider>
			</CookiesProvider>
		</BrowserRouter>
	</React.StrictMode>
);
